"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegeneratePdf = exports.GetPdfVersions = exports.GetFlattenedPdf = exports.UpdateDocumentField = exports.GenerateDocument = exports.GetDocumentTemplates = exports.GetDocumentTemplateFile = exports.GetDocumentTemplate = exports.AddDocumentSignature = exports.GetDocumentSignatures = exports.GetDocumentSignatureStatus = exports.GetDocumentsByStatus = exports.DeleteDocument = exports.GetDocument = void 0;
var HttpClient_1 = require("../core/HttpClient");
/**
 * Get a single document by ID
 * Backend: DocumentInstanceController@show (lines 19-84)
 * Returns: { data: { document: {...} } }
 */
var GetDocument = function (documentId) {
    return HttpClient_1.HttpClient.get("documents/".concat(documentId));
};
exports.GetDocument = GetDocument;
/**
 * Delete a document instance
 * Backend: DocumentInstanceController@destroy
 * Endpoint: DELETE /documents/{id}
 */
var DeleteDocument = function (documentId) {
    return HttpClient_1.HttpClient.delete("documents/".concat(documentId));
};
exports.DeleteDocument = DeleteDocument;
/**
 * Get documents for a specific user
 * Backend: UserDocumentController@index (lines 16-85)
 * Endpoint: GET /documents/users/{user_id}/documents?status=...
 * Returns: { data: [...] }
 */
var GetDocumentsByStatus = function (params) {
    var queryParams = new URLSearchParams();
    if (params.status) {
        queryParams.append("status", params.status);
    }
    if (params.template_id) {
        queryParams.append("template_id", params.template_id.toString());
    }
    var endpoint = "documents/users/".concat(params.user_id, "/documents").concat(queryParams.toString() ? "?" + queryParams.toString() : "");
    return HttpClient_1.HttpClient.get(endpoint);
};
exports.GetDocumentsByStatus = GetDocumentsByStatus;
/**
 * Get signature status for a document
 */
var GetDocumentSignatureStatus = function (documentId) {
    return HttpClient_1.HttpClient.get("documents/".concat(documentId, "/signature-status"));
};
exports.GetDocumentSignatureStatus = GetDocumentSignatureStatus;
/**
 * Get all signatures for a document
 * Backend: DocumentSignatureController@index (lines 18-61)
 * Returns: { document_signatures, field_signatures, pending_signatures, requirements }
 */
var GetDocumentSignatures = function (documentId) {
    return HttpClient_1.HttpClient.get("documents/".concat(documentId, "/signatures"));
};
exports.GetDocumentSignatures = GetDocumentSignatures;
/**
 * Add a signature to a document
 */
var AddDocumentSignature = function (documentId, data) {
    return HttpClient_1.HttpClient.post("documents/".concat(documentId, "/signatures"), data);
};
exports.AddDocumentSignature = AddDocumentSignature;
/**
 * Get a document template by ID
 * Backend: DocumentTemplateController@show
 * Returns template with file_url proxy endpoint
 */
var GetDocumentTemplate = function (templateId) {
    return HttpClient_1.HttpClient.get("documents/templates/".concat(templateId));
};
exports.GetDocumentTemplate = GetDocumentTemplate;
/**
 * Get document template PDF file
 * Backend: DocumentTemplateController@serveFile
 * Returns PDF file as ArrayBuffer for PDF.js
 */
var GetDocumentTemplateFile = function (templateId) {
    return HttpClient_1.HttpClient.get("documents/templates/".concat(templateId, "/file"), {
        responseType: "arraybuffer",
        headers: {
            Accept: "application/pdf",
        },
    });
};
exports.GetDocumentTemplateFile = GetDocumentTemplateFile;
var GetDocumentTemplates = function (params) {
    var queryParams = new URLSearchParams();
    if (params === null || params === void 0 ? void 0 : params.status) {
        queryParams.append("status", params.status);
    }
    if (params === null || params === void 0 ? void 0 : params.per_page) {
        queryParams.append("per_page", params.per_page.toString());
    }
    if (params === null || params === void 0 ? void 0 : params.page) {
        queryParams.append("page", params.page.toString());
    }
    var endpoint = "documents/templates".concat(queryParams.toString() ? "?" + queryParams.toString() : "");
    return HttpClient_1.HttpClient.get(endpoint);
};
exports.GetDocumentTemplates = GetDocumentTemplates;
var GenerateDocument = function (data) {
    return HttpClient_1.HttpClient.post("documents/generate", data);
};
exports.GenerateDocument = GenerateDocument;
var UpdateDocumentField = function (documentId, fieldName, value) {
    return HttpClient_1.HttpClient.put("documents/".concat(documentId, "/fields/").concat(fieldName), { value: value });
};
exports.UpdateDocumentField = UpdateDocumentField;
/**
 * Get the latest flattened PDF for a document
 * Backend: DocumentPdfController@getLatestFlattened
 * Endpoint: GET /documents/{id}/flattened-pdf
 */
var GetFlattenedPdf = function (documentId) {
    return HttpClient_1.HttpClient.get("documents/".concat(documentId, "/flattened-pdf"));
};
exports.GetFlattenedPdf = GetFlattenedPdf;
/**
 * Get all PDF versions for a document
 * Backend: DocumentPdfController@listVersions
 * Endpoint: GET /documents/{id}/pdfs
 */
var GetPdfVersions = function (documentId) {
    return HttpClient_1.HttpClient.get("documents/".concat(documentId, "/pdfs"));
};
exports.GetPdfVersions = GetPdfVersions;
/**
 * Request regeneration of the flattened PDF
 * Backend: DocumentPdfController@regenerate
 * Endpoint: POST /documents/{id}/regenerate-pdf
 * Returns 202 Accepted - PDF generation is queued
 */
var RegeneratePdf = function (documentId) {
    return HttpClient_1.HttpClient.post("documents/".concat(documentId, "/regenerate-pdf"));
};
exports.RegeneratePdf = RegeneratePdf;
